module.exports = __webpack_public_path__ + "img/7_28.0999a066.png";